module.exports = "/_next/static/images/eb515ece26793865c4f3eb86358c8ad2-headphone.svg.webp";